import { createStorage } from 'unstorage';
import lruCacheDriver from 'unstorage/drivers/lru-cache';

const driver = lruCacheDriver({
  max: 2000, // records number
  ttl: 1000 * 60 * 60 * 24, // 1 day
});

export const lruCache = createStorage({
  driver,
});
